<template>
  <div class="my-2 pa-3 encarte-card">
    <span class="pa-1 title">Produtos fora do encarte</span>
    <v-container fluid class="pa-1">
      <v-layout>
        <v-flex xs6>
          <v-list class="my-3">
            <v-list-item>
              <span class="list-item"
                >{{ items[0].text }} <strong class="ml-2">{{ items[0].value | localeString(2) | currency }}</strong></span
              >
            </v-list-item>
            <v-list-item>
              <span class="list-item"
                >{{ items[1].text }} <strong class="ml-2">{{ items[1].value | localeString(2) | currency }}</strong></span
              >
            </v-list-item>
            <v-list-item>
              <span class="list-item"
                >{{ items[2].text }} <strong class="ml-2">{{ items[2].value | localeString(2) | currency }}</strong></span
              >
            </v-list-item>
            <v-list-item>
              <span class="list-item"
                >{{ items[3].text }} <strong class="ml-2">{{ items[3].value | localeString(1) | percent }}</strong></span
              >
            </v-list-item>
          </v-list>
        </v-flex>
        <v-flex xs1 offset-xs1> </v-flex>
        <v-flex xs4>
          <encarte-chart class="chart" is-currency :chartData="chartData" />
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import EncarteChart from '@/modules/campanhas/resultados-encarte/views/pages/EncarteChart.vue'
import { mapGetters } from 'vuex'
import { colors } from '@/config/colors.js'

export default {
  components: {
    EncarteChart,
  },
  computed: {
    ...mapGetters(['faturamentoTodosProdutos', 'faturamentoEncarteProdutos', 'faturamentoFora', 'percentualFora']),
    items() {
      return [
        {
          text: 'Faturamento dos cupons com produto(s) do encarte',
          value: this.faturamentoTodosProdutos,
          isCurrency: true,
        },
        {
          text: 'Faturamento dos produtos do encarte',
          value: this.faturamentoEncarteProdutos,
          isCurrency: true,
        },
        {
          text: 'Faturamento dos produtos fora do encarte',
          value: this.faturamentoFora,
          isCurrency: true,
        },
        {
          text: 'Percentual de produtos fora do encarte',
          value: this.percentualFora,
          isPercent: true,
        },
      ]
    },
    chartData() {
      return {
        labels: ['Total', 'Encarte'],
        datasets: [
          {
            label: 'Quantidade',
            backgroundColor: colors[0],
            strokeColor: colors[0],
            borderColor: colors[0],
            data: [this.faturamentoFora, this.faturamentoEncarteProdutos],
            fill: false,
            datalabels: { display: true },
          },
        ],
      }
    },
  },
}
</script>

<style lang="scss">
.encarte-card {
  .chart {
    max-height: 350px;
  }
}
</style>
